import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { getSelectPageUserAuth } from "@/util/authutil";
import { enLocale } from "@/i18n/routing";
export const RoasterCafe = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  const select_user_auth = getSelectPageUserAuth(params, "roaster")?.user_auth;
  Debug(select_user_auth);

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_cafe","system_table_pk":["roaster_seq","roaster_cafe_seq"],"system_table_page":"RoasterCafe","system_table_path":"roaster/cafe/list","system_table_page_name":"RoasterCafe","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roastercafe","system_table_detail_result":"detail_result","system_table_search_column":["roaster_cafe_auth"],"system_table_search_select":["roaster_cafe_nick_locale","roaster_cafe_nick","roaster_cafe_name_locale","roaster_cafe_name"],"system_table_order_column":["roaster_cafe_auth","rgst_at","roaster_cafe_nick_locale","roaster_cafe_name_locale"],"system_table_default_name_column":"roaster_cafe_nick_locale","system_table_en_name_column":"roaster_cafe_nick","system_table_use_column":"roaster_cafe_use"}
    //--info--}

    case "RoasterCafe":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/cafe/list/detail/", saveFetch: { fetchUrl: "/api/roaster/cafe/list/edit" } },
        listFetch: { fetchUrl: "/api/roaster/cafe/list/list" },
        dataResultName: "detail_result",
        dataName: "RoasterCafeData",
        editCheck: true,
        editReload: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_cafe_seq: { ...dc.seq, required: true },
          // roaster_cafe_uuid: { ...dc.input },
          roaster_cafe_nick_locale: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          roaster_cafe_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_cafe_level: { ...dc.number },
          roaster_cafe_auth: {
            ...dc.select,
            codeGroup: "PSAUTH",
            maxLength: 300,
            showCount: true,
            update: {
              selectFilter: {
                code_id: select_user_auth === "OWN" ? ["CSTMR", "CAFE", "RSTR", "EXCLD"] : ["CSTMR", "CAFE", "EXCLD"],
              },
            },
          },
          roaster_cafe_desc: { ...dc.textAreaM, readOnly: true },
          roaster_cafe_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_cafe_uuid",
        base64Field: ["roaster_cafe_uuid"],
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "PSAUTH", label: "roaster_cafe_auth", placeholder: "roaster_cafe_auth" },
          { ...dc.listSearchUse, field: "search1", label: "roaster_cafe_use", placeholder: "roaster_cafe_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
        ],
        listOrder: [
          "roaster_cafe_auth_orderdesc",
          "roaster_cafe_auth_orderasc",
          "roaster_cafe_nick_orderdesc",
          "roaster_cafe_nick_orderasc",
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_cafe_seq",
          //"roaster_cafe_uuid",
          params?.locale === enLocale ? "roaster_cafe_nick" : "roaster_cafe_nick_locale",
          //"roaster_cafe_level",
          { field: "roaster_cafe_auth", codeGroup: "PSAUTH" },
          { field: "roaster_cafe_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_cafe","system_table_pk":["roaster_seq","roaster_cafe_seq"],"system_table_page":"RoasterCafeRegister","system_table_path":"roaster/cafe/register","system_table_page_name":"RoasterCafeRegister","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_cafe_auth","roaster_cafe_use"],"system_table_search_select":["roaster_cafe_name","roaster_cafe_nick"],"system_table_order_column":["roaster_cafe_auth","roaster_cafe_nick","roaster_cafe_name","rgst_at"],"system_table_default_name_column":"roaster_cafe_name","system_table_use_column":"roaster_cafe_use"}
    //--info--}

    case "RoasterCafeRegister":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/cafe/register/detail/", saveFetch: { fetchUrl: "/api/roaster/cafe/register/edit" } },
        listFetch: { fetchUrl: "/api/roaster/cafe/register/list" },
        dataResultName: "detail_result",
        dataName: "RoasterCafeRegisterData",
        editCheck: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_cafe_seq: { ...dc.seq, required: true },
          // roaster_cafe_uuid: { ...dc.input },
          roaster_cafe_nick_locale: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          roaster_cafe_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_cafe_level: { ...dc.number },
          roaster_cafe_auth: {
            ...dc.select,
            codeGroup: "PSAUTH",
            maxLength: 300,
            showCount: true,
            selectFilter: {
              code_id: ["CSTMR", "WTSGNP", "HLD", "CNCL", "RJCT"],
            },
          },
          roaster_cafe_desc: { ...dc.textAreaM, readOnly: true },
          roaster_cafe_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_cafe_uuid",
        base64Field: ["roaster_cafe_uuid"],
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "PSAUTH", label: "roaster_cafe_auth", placeholder: "roaster_cafe_auth" },
          { ...dc.listSearchUse, field: "search1", label: "roaster_cafe_use", placeholder: "roaster_cafe_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
        ],
        listOrder: [
          "roaster_cafe_auth_orderdesc",
          "roaster_cafe_auth_orderasc",
          "roaster_cafe_nick_orderdesc",
          "roaster_cafe_nick_orderasc",
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_cafe_seq",
          //"roaster_cafe_uuid",
          params?.locale === enLocale ? "roaster_cafe_nick" : "roaster_cafe_nick_locale",
          //"roaster_cafe_level",
          { field: "roaster_cafe_auth", codeGroup: "PSAUTH" },
          { field: "roaster_cafe_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    case "RoasterCafeEtc":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/cafe/etc/detail/", saveFetch: { fetchUrl: "/api/roaster/cafe/etc/edit" } },
        listFetch: { fetchUrl: "/api/roaster/cafe/etc/list" },
        dataResultName: "detail_result",
        dataName: "RoasterCafeEtcData",
        editCheck: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_cafe_seq: { ...dc.seq, required: true },
          // roaster_cafe_uuid: { ...dc.input },
          roaster_cafe_nick_locale: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          roaster_cafe_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_cafe_level: { ...dc.number },
          roaster_cafe_auth: {
            ...dc.select,
            codeGroup: "PSAUTH",
            maxLength: 300,
            showCount: true,
            selectFilter: {
              code_id: ["CNCL", "RJCT", "RJN", "FIRE", "EXCLD"],
            },
          },
          roaster_cafe_desc: { ...dc.textAreaM, readOnly: true },
          roaster_cafe_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_cafe_uuid",
        base64Field: ["roaster_cafe_uuid"],
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "PSAUTH", label: "roaster_cafe_auth", placeholder: "roaster_cafe_auth" },
          { ...dc.listSearchUse, field: "search1", label: "roaster_cafe_use", placeholder: "roaster_cafe_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_cafe_nick", placeholder: "roaster_cafe_nick" },
        ],
        listOrder: [
          "roaster_cafe_auth_orderdesc",
          "roaster_cafe_auth_orderasc",
          "roaster_cafe_nick_orderdesc",
          "roaster_cafe_nick_orderasc",
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_cafe_seq",
          //"roaster_cafe_uuid",
          params?.locale === enLocale ? "roaster_cafe_nick" : "roaster_cafe_nick_locale",
          //"roaster_cafe_level",
          { field: "roaster_cafe_auth", codeGroup: "PSAUTH" },
          { field: "roaster_cafe_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    default:
      return undefined;
  }
};
